<div
	[ngClass]="{
		'obg-accordion-content-expanded-animation': animationEnabled && isExpanded,
		'obg-accordion-content-collapsed-animation': animationEnabled && !isExpanded,
	}"
	(animationend)="setDisplay(isExpanded)"
>
	<ng-container *ngIf="isContentVisible || hideOnly">
		<ng-container
			[ngTemplateOutlet]="templateRef ? templateRef : ngContent"
			[ngTemplateOutletContext]="templateContext"
		></ng-container>
	</ng-container>

	<ng-template #ngContent>
		<ng-content></ng-content>
	</ng-template>
</div>
